import { screens } from '@nrdy-marketing-engine/theming/src/screens';
import { useCallback, useEffect, useRef, useState } from 'react';

export default function useSearchTakeover() {
  const [showSearchTakeover, setShowSearchTakeover] = useState(false);
  const searchRef = useRef<HTMLInputElement>();

  // Show or hide the search takeover when the window is resized below the md breakpoint
  const checkSearchTakeover = useCallback(() => {
    setShowSearchTakeover(
      window.innerWidth < parseInt(screens.md) && searchRef.current === document.activeElement
    );
  }, [searchRef]);

  // Check during window resize whether we should take over
  useEffect(() => {
    window.addEventListener('resize', checkSearchTakeover, { passive: true });
    return () => window.removeEventListener('resize', checkSearchTakeover);
  }, [checkSearchTakeover]);

  return {
    searchRef,
    checkSearchTakeover,
    showSearchTakeover,
  };
}
